import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=1d220d90&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports